import React from 'react'
import { getLmsInsightLaunchReport } from '../../../api-new/state/analytics'
import { LaunchRefusals } from './launch-refusals'
import { LaunchSummary } from './launch-summary'
import { LaunchTiles, LaunchesChart, Outcomes, Scores } from './launch-overview'
import { launchQuery } from './lms-insight-query'
import { ReportStatus } from './report-status'
import { useLmsReports } from './use-lms-reports'

// The downloads the Launches tab offers: the three reports, each as CSV and
// as JSON lines (export-menu.js).
export const LAUNCH_EXPORTS = [
  { report: 'series', label: 'Launches over time' },
  { report: 'summary', label: 'Summary by connection and course' },
  { report: 'refusals', label: 'Refusals' }
]

const REPORTS = ['series', 'summary', 'refusals']

// A range with no launch, no completion, no refusal and no row.
const nothingIn = ({ series, summary, refusals }) =>
  series.totals.launches === 0 &&
  series.totals.completions === 0 &&
  series.totals.refusals === 0 &&
  summary.rows.length === 0 &&
  refusals.rows.length === 0

// The Launches tab (Analytics > LMS > Launches): how many launches the
// organization's LMS connections made, who got in, how the sessions ended,
// the scores, and what was refused. Three reports of the analytics service,
// read together on load, when a filter changes and on Refresh; no polling.
export const LaunchesTab = ({ filters, refreshKey }) => {
  const query = launchQuery(filters)

  const report = useLmsReports(
    () => Promise.all(REPORTS.map(name => getLmsInsightLaunchReport(name, query))).then(([series, summary, refusals]) => ({ series, summary, refusals })),
    `${query}|${refreshKey}`
  )

  return (
    <ReportStatus
      report={report}
      subject="LMS launches"
      empty="No LMS launches in this range."
      emptyHint="Try a wider range, or another LMS connection or course."
      isEmpty={nothingIn}>
      {({ series, summary, refusals }) =>
        <div data-testid="lms-launches">
          <LaunchTiles totals={series.totals} />
          <div className="row g-3">
            <div className="col-lg-8">
              <LaunchesChart buckets={series.buckets} />
            </div>
            <div className="col-lg-4">
              <Outcomes totals={series.totals} />
            </div>
          </div>
          <Scores totals={summary.totals} />
          <LaunchSummary summary={summary} />
          <LaunchRefusals refusals={refusals} series={series} tz={filters.tz} />
        </div>}
    </ReportStatus>
  )
}
